import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: {
    primary: "#5EBCEE", // sky blue
    secondary: "#7B8790", // grey
    accent: "#FEB632", // orange
    error: "#DD361F", // red
    info: "#F5F8FA", // background 
    success: "#18B720", // green
    warning: "#fff" //white
  }
});
